module.exports = __webpack_public_path__ + "static/media/AppleAppStore.f6d41c3d.svg";